import Vue from "vue";
import Router from "vue-router";
import index from "@/components/index";
import about from "@/components/about";
import event from "@/components/Events";
import services from "@/components/services";
import portfolio2 from "@/components/portfolio2";
import portfolio3 from "@/components/portfolio3";
import portfolio4 from "@/components/portfolio4";
import blog from "@/components/blog";
import blogdetail from "@/components/blogdetail";
import contact from "@/components/contact";
import error from "@/components/error";
import login from "@/components/login";
import signup from "@/components/signup";
import capabilities from "@/components/capabilities";
import privacy from "@/components/privacy";
import ria from "@/components/ria";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            name: "index",
            component: index,
        },
        {
            path: "/privacy",
            name: "privacy",
            component: privacy,
        },
        {
            path: "/capabilities",
            name: "capabilities",
            component: capabilities,
        },
        {
            path: "/about",
            name: "about",
            component: about,
        },
        {
            path: "/Events",
            name: "event",
            component: event,
        },
        {
            path: "/services",
            name: "services",
            component: services,
        },
        {
            path: "/portfolio2",
            name: "portfolio2",
            component: portfolio2,
        },
        {
            path: "/portfolio3",
            name: "portfolio3",
            component: portfolio3,
        },
        {
            path: "/portfolio4",
            name: "portfolio4",
            component: portfolio4,
        },
        {
            path: "/blog",
            name: "blog",
            component: blog,
        },
        {
            path: "/news/:id",
            name: "News",
            meta: { auth: true, name: "News" },
            component: blogdetail,
        },
        {
            path: "/error",
            name: "error",
            component: error,
        },
        {
            path: "/login",
            name: "login",
            component: login,
        },
        {
            path: "/signup",
            name: "signup",
            component: signup,
        },
        {
            path: "/contact",
            name: "contact",
            component: contact,
        },
        {
            path: "/ria",
            name: "ria",
            component: ria,
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
});
